export default __webpack_public_path__ + "static/media/Company.50eb21cd.pdf";